export function dialog_gallery(state = false, action) {
  if (action.type === 'SHOW_DIALOG_GALLERY') {
    return action.visible;
  }
  if (action.type === 'CLOSE_DIALOG_GALLERY') {
    return action.visible;
  }
  return state;
}
